<template>
  <DeletionModal
    :title="$t('confirmation')"
    :label="$t('ConfirmationMSG')"
    :isModal="props.showModal"
    @close="props.closeModal"
    @select="props.confirmDeletionFn"
  />
  <div class="soar-container">
    <div class="w-full my-8" :class="containerClass">
      <div class="flex items-center justify-between border-b border-brand-gray-350 w-full">
        <div class="py-6 w-full">
          <h2 class="text-2xl text-gray-700 font-normal mx-3">
            {{ $t(props.panelTitle) }}
          </h2>
        </div>
        <slot name="searchHeadOperation"> </slot>
      </div>
      <div class="w-full my-6">
        <Form
          :initial-values="initialValues"
          :keep-values="true"
          class="md:flex flex-col gap-y-5"
          @submit="(values) => props.onSearch(values)"
          v-slot="{ values, resetForm }"
        >
          <fieldset class="border-2 border-primary rounded p-4 flex flex-col gap-y-5">
            <legend class="px-4 text-xl">{{ $t('search') }}</legend>
            <div class="flex flex-row flex-wrap">
              <slot name="searchPanel" :values="values">
                <DraftSearchPanel :initialValues="initialValues" />
              </slot>

              <div class="flex justify-end items-center w-full mt-2">
                <slot name="searchOperation" :resetForm="resetForm" :values="values">
                  <FilledButton class="px-5 py-1.5 text-white">
                    <i class="fa fa-search text-white"></i>
                    {{ $t('search') }}
                  </FilledButton>
                </slot>
              </div>
            </div>
          </fieldset>
        </Form>
      </div>
      <div class="w-full">
        <slot name="searchResult"></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
import FilledButton from '@/components/Buttons/Filled.vue'
import DeletionModal from '@/components/Modal/index.vue'
import DraftSearchPanel from '@/views/individual/draft/DraftSearchPanel.vue'
import { Form } from 'vee-validate'

const props = defineProps({
  panelTitle: {
    type: String,
    default: ''
  },
  initialValues: {
    type: Object
  },
  confirmDeletionFn: {
    type: Function
  },
  onSearch: {
    type: Function
  },
  closeModal: {
    type: Function
  },
  showModal: {
    type: Boolean
  },
  containerClass: {
    type: String
  }
})
</script>

<style></style>
